import { forwardRef, memo, type InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const Input = memo(
  forwardRef<HTMLInputElement, InputProps>(function Input(
    { className, ...props },
    ref,
  ) {
    return (
      <input
        ref={ref}
        className={cn(
          "h-9 w-full appearance-none rounded-md border border-neutral-200 bg-white px-3 font-sans text-sm text-neutral-800 outline-none transition-colors duration-150 placeholder:text-slate-400",
          "focus:border-primary-500 focus:ring-[3px] focus:ring-primary-100",
          "disabled:cursor-not-allowed disabled:bg-neutral-50 disabled:opacity-50",
          "dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100",
          className,
        )}
        {...props}
      />
    );
  }),
);

export default Input;
